export default "/assets/images/dusty-taupe-sm.3baae2c7f0640049.jpg";